// src/App.jsx
import React from "react";
import { Routes, Route } from "react-router-dom"; // 1. Import Router components
import Home from "../src/pages/Home";
import AboutHero from "./component/about_us_page/AboutUs_page";
import ServicesParm from "./component/services_page/Services_page";
import EventParm from "./component/events_page/Events_page";
import NewsPageParm from "./component/news_page/News_page";
import IntacKL from "./component/intac_kl_page/Intac_kl_page";
import IntacKLPage1 from "./component/intac_kl_page/intac_2026_page1";
import Footer from "./component/Footer";
import Navbar from "./component/Navbar";
import EventsDetailPage from "./component/events_page/event_detail_page";
import ArboricaAll from "./component/arborica/Arborica_all_page";
import NewsDetailPage from "./component/news_page/news_detail_page";
import MembershipPage from "./component/membership/membership_page";
import MemberRegistration from "./component/membership/membership_page_2";
import MembershipProposer from "./component/membership/membership_proposer";
// import ArboricaVol1 from "./component/arborica/arborica_flipbook";
import LoginPage from "./component/membership/login_page/login_page";
import MemberDashboard from "./component/membership/member_dashboard/member_dashboard_page";
import ForgotPassword from "./component/membership/login_page/forgot_password";
import ResetPassword from "./component/membership/login_page/reset_password";
import ProposerRequests from "./component/membership/member_dashboard/proposer_request_page";
import RegistrationStatus from "./component/membership/member_dashboard/registration_status_page";
import UpdateProfile from "./component/membership/edit_profile/membership_edit_profile";
import PaymentPage from "./component/membership/membership_payment_page/membership_payment_page";
import EmailUpdateHandler from "./component/membership/login_page/update_email";
import ChangeEmail from "./component/membership/login_page/forgot_email";
import FirebaseActionHandler from "./component/firebase/authentication_handler";
import PenaungDiraja from "./component/events_page/penaung_diraja";
import ArchiveEventList from "./component/archive/event/archive_event_list";
import ArchiveEventDetail from "./component/archive/event/archive_event_detail";
import ArchiveNewsList from "./component/archive/news/archive_news_list";
import ArchiveNewsDetail from "./component/archive/news/archive_news_detail";
import AdminDashboard from "./component/admin/admin_dashboard";
import AdminMemberList from "./component/admin/admin_member_list";
import AdminApprovalList from "./component/admin/admin_approval_list";
import AdminContentDashboard from "./component/admin/admin_content_dashboard";
import AdminContentForm from "./component/admin/admin_content_update_form";
import TimelineArchive from "./component/archive/timeline_archive";
import AdminContentManage from "./component/admin/admin_content_manage";
import AuthHandler from "./component/membership/login_page/AuthHandler";
import FloatingCountdown from "./component/intac_kl_page/floatingCountdown";


import "./App.css";

export default function App() {
  return (
    <div className="bg-[#f5f8f2] min-h-screen font-sans">
      {/* Navbar stays at the top on all pages */}
      <Navbar />

      {/* 3. Define which component shows up based on the URL */}
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about-parm" element={<AboutHero />} />
        <Route path="/services-parm" element={<ServicesParm />} />
        <Route path="/events-parm" element={<EventParm />} />
        <Route path="/news-parm" element={<NewsPageParm />} />
        <Route path= "/intac2026-parm" element={<IntacKL />} />
        <Route path= "/intac2026-page1-parm" element={<IntacKLPage1 />} />
         <Route path= "/eventDetailPage" element={<EventsDetailPage />} />
         <Route path= "/arborica-all-parm" element={<ArboricaAll />} />
         <Route path= "/newsDetailPage" element={<NewsDetailPage/>} />
         <Route path="/membership-parm" element={<MembershipPage/>}/>
         <Route path="/membership-registration-parm" element={<MemberRegistration/>}/>
         <Route path="/membership-proposer-parm" element={<MembershipProposer/>}/>
         <Route path="/login-parm" element={<LoginPage/>}/>
         <Route path="/member-dashboard-parm" element={<MemberDashboard/>}/>
         <Route path="/forgot-password-parm" element={<ForgotPassword/>}/>
         <Route path="/reset-password-parm" element={<ResetPassword/>}/>
         <Route path="/proposer-request-parm" element={<ProposerRequests/>}/>
         <Route path="/registration-status-parm" element={<RegistrationStatus/>}/>
         <Route path="/update-profile-parm" element={<UpdateProfile/>}/>
         <Route path="/membership-payment-parm" element={<PaymentPage/>}/>
         <Route path="/update-email-parm" element={<EmailUpdateHandler/>}/>
         <Route path="/change-email-parm" element={<ChangeEmail/>}/>
         <Route path="/auth-handler" element={<FirebaseActionHandler/>}/>
        <Route path="/article-penaung-diraja-parm" element={<PenaungDiraja/>}/>

        <Route path="/archive-event-list-parm" element={<ArchiveEventList />} />
        <Route path="/archive-event-detail-parm/:eventId" element={<ArchiveEventDetail />} />
        <Route path="/archive-news-list-parm" element={<ArchiveNewsList />} />
        <Route path="/archive-news-detail-parm/:newsId" element={<ArchiveNewsDetail />} />

        <Route path="/admin-parm" element={<AdminDashboard/>}/>
        <Route path="/admin-parm/member-list" element={<AdminMemberList/>}/>
        <Route path="/admin-parm/approval-member-list" element={<AdminApprovalList/>}/>
        <Route path="/admin-parm/content-dashboard-parm" element={<AdminContentDashboard/>}/>
        <Route path="/admin-parm/content-dashboard-parm/news/new" element={<AdminContentForm type="news" />} />
        <Route path="/admin-parm/content-dashboard-parm/news/:id" element={<AdminContentForm type="news" />} />
        <Route path="/admin-parm/content-dashboard-parm/events/new" element={<AdminContentForm type="event" />} />
        <Route path="/admin-parm/content-dashboard-parm/events/:id" element={<AdminContentForm type="event" />} />

        <Route path="/archive-timeline-parm" element={<TimelineArchive />} />

        <Route path="/admin-parm/content-manage-parm/event" element={<AdminContentManage type="event"/>} />
        <Route path="/admin-parm/content-manage-parm/news" element={<AdminContentManage type="news"/>} />
        {/* <Route path="/auth-handler" element={<AuthHandler/>}/> */}



        {/* <Route path= "/arboricaVol1" element={<ArboricaVol1 />} /> */}
      </Routes>

      {/* <FloatingCountdown />  */}

      {/* Footer stays at the bottom on all pages */}
      <Footer />
    </div>
  );
}